'use client'

import { LoginPage } from '@/components/auth/LoginPage'

export function EnterpriseLoginPage({ returnPath }: { returnPath: string }) {
  return <LoginPage returnPath={returnPath} variant="enterprise" />
}
